import api from '../api';

const designCaseApi = {
  // Lấy tất cả design cases của seller
  getSellerCases: async (token, params = {}) => {
    try {
      const response = await api.get('/design-cases/', {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Tạo design case mới
  createDesignCase: async (token, caseData) => {
    try {
      const response = await api.post('/seller/design-cases/', caseData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Tạo nhiều design cases cùng lúc
  createMultipleDesignCases: async (token, casesData) => {
    try {
      const response = await api.post('/seller/design-cases/bulk-create', casesData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy chi tiết design case
  getDesignCaseById: async (token, caseId) => {
    try {
      const response = await api.get(`/seller/design-cases/${caseId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Cập nhật design case
  updateDesignCase: async (token, caseId, caseData) => {
    try {
      const response = await api.put(`/seller/design-cases/${caseId}`, caseData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Xóa design case
  deleteDesignCase: async (token, caseId) => {
    try {
      const response = await api.delete(`/seller/design-cases/${caseId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Bulk delete design cases
  bulkDeleteDesignCases: async (token, caseIds) => {
    try {
      const response = await api.delete('/seller/design-cases/bulk-delete', {
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: { caseIds }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Approve design case
  approveDesignCase: async (token, caseId, approvalData) => {
    try {
      const response = await api.put(`/design-cases/${caseId}/approve`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Reject design case
  rejectDesignCase: async (token, caseId) => {
    try {
      const response = await api.put(`/design-cases/${caseId}/reject`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Cancel design case
  cancelDesignCase: async (token, caseId) => {
    try {
      const response = await api.put(`/design-cases/${caseId}/cancel`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy thống kê design cases
  getDesignCaseStats: async (token, timeRange = 'all') => {
    try {
      const response = await api.get('/seller/design-cases/stats', {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { timeRange }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Approve design file
  approveDesign: async (token, caseId, fileUrl) => {
    try {
      const response = await api.post(`/seller/design-cases/${caseId}/approve-design`, {
        design_file: fileUrl
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Reject design file
  rejectDesign: async (token, caseId, fileUrl) => {
    try {
      const response = await api.post(`/seller/design-cases/${caseId}/reject-design`, {
        design_file: fileUrl
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy danh sách orders có thể tạo case
  getAvailableOrders: async (token) => {
    try {
      const response = await api.get('/seller/orders/available-for-design', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy chi tiết order để tạo case
  getOrderForDesignCase: async (token, orderId) => {
    try {
      const response = await api.get(`/seller/orders/${orderId}/design-case-info`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Upload design files (for seller to upload reference materials)
  uploadDesignFiles: async (token, caseId, files) => {
    try {
      const formData = new FormData();
      files.forEach(file => {
        formData.append('files', file);
      });

      const response = await api.post(`/seller/design-cases/${caseId}/upload-files`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Download design files
  downloadDesignFiles: async (token, caseId) => {
    try {
      const response = await api.get(`/seller/design-cases/${caseId}/download`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy lịch sử design case
  getDesignCaseHistory: async (token, caseId) => {
    try {
      const response = await api.get(`/seller/design-cases/${caseId}/history`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Gửi feedback cho designer
  sendFeedback: async (token, caseId, feedbackData) => {
    try {
      const response = await api.post(`/seller/design-cases/${caseId}/feedback`, feedbackData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy danh sách designers
  getDesigners: async (token) => {
    try {
      const response = await api.get('/seller/designers', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Assign designer cho case (nếu có quyền)
  assignDesigner: async (token, caseId, designerId) => {
    try {
      const response = await api.put(`/seller/design-cases/${caseId}/assign`, {
        designerId
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy notifications cho design cases
  getDesignCaseNotifications: async (token) => {
    try {
      const response = await api.get('/seller/design-cases/notifications', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Mark notification as read
  markNotificationRead: async (token, notificationId) => {
    try {
      const response = await api.put(`/seller/notifications/${notificationId}/read`, {}, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Search design cases
  searchDesignCases: async (token, searchParams) => {
    try {
      const response = await api.get('/seller/design-cases/search', {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: searchParams
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Filter design cases
  filterDesignCases: async (token, filters) => {
    try {
      const response = await api.get('/seller/design-cases/filter', {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: filters
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Export design cases
  exportDesignCases: async (token, params = {}) => {
    try {
      const response = await api.get('/seller/design-cases/export', {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params,
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get design case timeline
  getDesignCaseTimeline: async (token, caseId) => {
    try {
      const response = await api.get(`/seller/design-cases/${caseId}/timeline`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update design case priority
  updateDesignCasePriority: async (token, caseId, priority) => {
    try {
      const response = await api.put(`/seller/design-cases/${caseId}/priority`, {
        priority
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update design case deadline
  updateDesignCaseDeadline: async (token, caseId, deadline) => {
    try {
      const response = await api.put(`/seller/design-cases/${caseId}/deadline`, {
        deadline
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get design case analytics
  getDesignCaseAnalytics: async (token, caseId) => {
    try {
      const response = await api.get(`/seller/design-cases/${caseId}/analytics`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Duplicate design case
  duplicateDesignCase: async (token, caseId, duplicateData = {}) => {
    try {
      const response = await api.post(`/seller/design-cases/${caseId}/duplicate`, duplicateData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get design case templates
  getDesignCaseTemplates: async (token) => {
    try {
      const response = await api.get('/seller/design-cases/templates', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create design case from template
  createDesignCaseFromTemplate: async (token, templateId, caseData) => {
    try {
      const response = await api.post(`/seller/design-cases/templates/${templateId}/create`, caseData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get design case comments
  getDesignCaseComments: async (token, caseId) => {
    try {
      const response = await api.get(`/seller/design-cases/${caseId}/comments`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Add comment to design case
  addDesignCaseComment: async (token, caseId, commentData) => {
    try {
      const response = await api.post(`/seller/design-cases/${caseId}/comments`, commentData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update comment
  updateDesignCaseComment: async (token, caseId, commentId, commentData) => {
    try {
      const response = await api.put(`/seller/design-cases/${caseId}/comments/${commentId}`, commentData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete comment
  deleteDesignCaseComment: async (token, caseId, commentId) => {
    try {
      const response = await api.delete(`/seller/design-cases/${caseId}/comments/${commentId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get design case attachments
  getDesignCaseAttachments: async (token, caseId) => {
    try {
      const response = await api.get(`/seller/design-cases/${caseId}/attachments`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Upload attachment to design case
  uploadDesignCaseAttachment: async (token, caseId, file, description = '') => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('description', description);

      const response = await api.post(`/seller/design-cases/${caseId}/attachments`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete attachment
  deleteDesignCaseAttachment: async (token, caseId, attachmentId) => {
    try {
      const response = await api.delete(`/seller/design-cases/${caseId}/attachments/${attachmentId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default designCaseApi; 
